module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/workshops.json
// module id = 1048
// module chunks = 27535781569577